
        var result = require("!!../../../../node_modules/css-loader/index.js!./settings-eventaction-perm.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/settings/settings-eventaction/settings-eventaction-perm.component.css
// module id = 2424
// module chunks = 1